import type React from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";

import type { IAppsIosIdentifierFilter } from "../../../../types/iosFiltersDto";
import type { IosIdentifierType } from "../types";
import { iosIdentifierTypeToAppsIdentifiers } from "../utils";

import { StyledDelimiter } from "./styles";

export const AppsIosIdentifiersFilterResult: React.FC<IFilterViewBaseModelProps<IAppsIosIdentifierFilter>> = ({
    value,
    onFilterUpdate,
    isExpanded,
}) => {
    const handleDelete = (type: IosIdentifierType) => (id: string) => {
        const updatedValue = {
            ...(value ?? {}),
            ...{ [type]: (value?.[type] || []).filter((value) => value !== id) },
        } as IAppsIosIdentifierFilter;
        onFilterUpdate(!updatedValue.bundleIds?.length && !updatedValue.trackIds?.length ? undefined : updatedValue);
    };

    const getChipItems = (type: IosIdentifierType) =>
        value?.[type]?.map((item) => ({ text: `${iosIdentifierTypeToAppsIdentifiers[type]}: ${item}`, id: item })) ??
        [];

    const trackIdsChips = getChipItems("trackIds");
    const bundleIdsChips = getChipItems("bundleIds");

    if (!value?.trackIds?.length && !value?.bundleIds?.length) {
        return null;
    }

    return (
        <>
            {trackIdsChips.length ? (
                <Flex flexWrap="wrap">
                    <LimitedChipItems
                        items={trackIdsChips}
                        onDelete={handleDelete("trackIds")}
                        maxItems={2}
                        delimiter={translate("si.find_apps.filters.identifier.OR")}
                        isTabExpanded={isExpanded}
                    />
                </Flex>
            ) : null}
            {trackIdsChips.length && bundleIdsChips.length ? (
                <StyledDelimiter>{translate("si.find_apps.filters.identifier.OR")}</StyledDelimiter>
            ) : null}
            {bundleIdsChips.length ? (
                <Flex flexWrap="wrap">
                    <LimitedChipItems
                        items={bundleIdsChips}
                        onDelete={handleDelete("bundleIds")}
                        maxItems={2}
                        delimiter={translate("si.find_apps.filters.identifier.OR")}
                        isTabExpanded={isExpanded}
                    />
                </Flex>
            ) : null}
        </>
    );
};
